import { connect } from 'react-redux'

import { hideAlert } from '../../../common/actions/common'
import AlertsStream from './alertsStream'

const mapStateToProps = (state) => {
  const { common: { alerts } } = state
  return {
    alerts
  }
}

const mapDispatchToProps = (dispatch) => {
  return {
    hideAlert: (message) => {
      dispatch(hideAlert(message))
    }
  }
}

const AlertsStreamContainer = connect(
  mapStateToProps,
  mapDispatchToProps
)(AlertsStream)

export default AlertsStreamContainer



// WEBPACK FOOTER //
// ./client/components/alerts/alertsStreamContainer.js